import { useEffect } from "react";
import { isIOSStandaloneMode } from "@/utils/platform";

const CSS_VAR_NAME = "--app-vh";

export function useViewportHeight() {
  useEffect(() => {
    const isStandalone = isIOSStandaloneMode();
    
    // Add class for CSS targeting
    if (isStandalone) {
      document.documentElement.classList.add("ios-standalone");
    }

    const setVh = () => {
      let height: number;

      // Standalone Mode: 使用 visualViewport.height（实际可见区域）
      if (isStandalone && window.visualViewport) {
        height = window.visualViewport.height;
        console.log("📐 Standalone mode - visualViewport.height:", height);
      } else {
        // 普通浏览器模式: 使用 window.innerHeight
        height = window.innerHeight;
        console.log("📐 Browser mode - window.innerHeight:", height);
      }

      const vh = height * 0.01;
      document.documentElement.style.setProperty(CSS_VAR_NAME, `${vh}px`);
      // Also set the full viewport height for use in CSS
      document.documentElement.style.setProperty("--viewport-height", `${height}px`);
      
      console.log(`✅ --app-vh 已更新为: ${vh}px (${height}px / 100)`);
    };

    setVh();

    // 监听窗口大小变化
    window.addEventListener("resize", setVh);
    window.addEventListener("orientationchange", setVh);

    // Standalone Mode: 额外监听 visualViewport 变化
    if (isStandalone && window.visualViewport) {
      window.visualViewport.addEventListener("resize", setVh);
      window.visualViewport.addEventListener("scroll", setVh);
    }

    return () => {
      window.removeEventListener("resize", setVh);
      window.removeEventListener("orientationchange", setVh);
      if (isStandalone && window.visualViewport) {
        window.visualViewport.removeEventListener("resize", setVh);
        window.visualViewport.removeEventListener("scroll", setVh);
      }
    };
  }, []);
}
